// eslint-disable-next-line import/prefer-default-export
export const leaveAReviewOfferText = (extendedOffer: boolean) =>
  `${
    extendedOffer
      ? "If you’ve used this product, leave a review to tell us and other customers what you thought about it. Receive up to $16 in promotional credits for submitting one of the first text, photo, or video reviews for this item."
      : "Customers can receive promotional credit when they post reviews."
  }`;
